module.exports = __webpack_public_path__ + "static/assets/a99551e8efe76ad2f70b7f9b967d514d.svg";